<template>
  <div>
    <ul class="tab-menu">
      <li v-for="(tab, index) in visibleTabs" 
          :key="index" 
          :class="{ active: currentTab === tab.name }"
          @click="currentTab = tab.name">
        {{ tab.label }}
      </li>
    </ul>

    <div v-for="tab in visibleTabs" :key="tab.name" v-if="currentTab === tab.name" class="bg-card">
      <div class="container py-3">
        <template v-if="tab.name === 'Detalles'">
          <h3 class="fw-bold mb-4 pt-3" v-if="hasAboutDetails">{{tab.label}}</h3>
          <div class="row mb-3 px-3" v-if="hasAboutDetails">
            <div class="col-md-4 px-0">
              <p class="mb-1 p-1" v-if="tipoPropiedadNombre"><strong>{{ $t('tab.propertyType') }}</strong> {{ tipoPropiedadNombre }}</p>
              <p class="mb-1 p-1" v-if="dataDetail.Propiedad_en_Venta"><strong>{{ $t('tab.propertyStatus') }}</strong> {{ dataDetail.Propiedad_en_Venta == 1 ? $t('tab.statusSale') : dataDetail.Propiedad_en_Alquiler == 1 ? $t('tab.statusRent') : dataDetail.Propiedad_en_Venta == 1 && dataDetail.Propiedad_en_Alquiler == 1 ? $t('tab.statusBoth') : '' }}</p>
              <p class="mb-1 p-1" v-if="dataDetail.Cuartos"><strong>{{ $t('tab.rooms') }}</strong> {{ dataDetail.Cuartos }}</p>
              <p class="mb-1 p-1" v-if="dataDetail.Banos"><strong>{{ $t('tab.bathrooms') }}</strong> {{ dataDetail.Banos }}</p>
              <p class="mb-1 p-1" v-if="dataDetail.Pisos"><strong>{{ $t('tab.floors') }}</strong> {{ dataDetail.Pisos }}</p>
              <p class="mb-1 p-1" v-if="dataDetail.Parqueos"><strong>{{ $t('tab.parking') }}</strong> {{ dataDetail.Parqueos }}</p>
              <p class="mb-1 p-1" v-if="dataDetail.Precio_de_Venta"><strong>{{ $t('detail.priceSale') }} {{ dataDetail.Precio_de_Venta > 0 ? ': ' : ''}}</strong>{{'$' + dataDetail.Precio_de_Venta }}</p>

            </div>
            <div class="col-md-4 px-0">
              <p class="mb-1 p-1" v-if="dataDetail.Precio_de_Alquiler"><strong>{{ $t('detail.priceRent') }} {{ dataDetail.Precio_de_Alquiler > 0 ? ': ' : ''}}</strong>{{'$' + dataDetail.Precio_de_Alquiler }}</p>
              <p class="mb-1 p-1" v-if="dataDetail.Area_en_m2"><strong>{{ $t('tab.propertySize') }}</strong> {{ Math.round(dataDetail.Area_en_m2) + ' ' + $t('tab.areaUnit') }}</p>
              <p class="mb-1 p-1" v-if="dataDetail.Lote_en_v2"><strong>{{ $t('tab.lotSize') }}</strong> {{ Math.round(dataDetail.Lote_en_v2) + ' ' + $t('tab.lotSizeUnit') }}</p>
              <p class="mb-1 p-1" v-if="dataDetail.Amueblado"><strong>{{ $t('tab.furnished') }}</strong> {{ dataDetail.Amueblado == 1 ? $t('tab.yes') : ''}}</p>
              <p class="mb-1 p-1" v-if="dataDetail.Linea_Blanca"><strong>{{ $t('tab.appliances') }}</strong> {{ dataDetail.Linea_Blanca == 1 ? $t('tab.yes') : ''}}</p>
              <p class="mb-1 p-1" v-if="dataDetail.Piscina"><strong>{{ $t('tab.pool') }}</strong> {{ dataDetail.Piscina == 1 ? $t('tab.yes') : ''}}</p>
              <p class="mb-1 p-1" v-if="dataDetail.En_Condominio"><strong>{{ $t('tab.gated') }}</strong> {{ dataDetail.En_Condominio == 1 ? $t('tab.yes') : ''}}</p>

            </div>
            <div class="col-md-4 px-0">
              <p class="mb-1 p-1" v-if="dataDetail.Seguridad_247"><strong>{{ $t('tab.security24') }}</strong> {{ dataDetail.Seguridad_247 == 1 ? $t('tab.yes') : ''}}</p>
              <p class="mb-1 p-1" v-if="dataDetail.Casa_Club"><strong>{{ $t('tab.clubhouse') }}</strong> {{ dataDetail.Casa_Club == 1 ? $t('tab.yes') : ''}}</p>
              <p class="mb-1 p-1" v-if="dataDetail.Juegos_Infantiles"><strong>{{ $t('tab.playground') }}</strong> {{ dataDetail.Juegos_Infantiles == 1 ? $t('tab.yes') : ''}}</p>
              <p class="mb-1 p-1" v-if="dataDetail.Gym"><strong>{{ $t('tab.gym') }}</strong> {{ dataDetail.Gym == 1 ? $t('tab.yes') : ''}}</p>
              <p class="mb-1 p-1" v-if="dataDetail.Bodega"><strong>{{ $t('tab.storage') }}</strong> {{ dataDetail.Bodega == 1 ? $t('tab.yes') : ''}}</p>
              <p class="mb-1 p-1" v-if="dataDetail.Cancha_Deportiva"><strong>{{ $t('tab.sportsCourt') }}</strong> {{ dataDetail.Cancha_Deportiva == 1 ? $t('tab.yes') : ''}}</p>
              <p class="mb-1 p-1" v-if="dataDetail.Garaje"><strong>{{ $t('tab.garage') }}</strong> {{ dataDetail.Garaje == 1 ? $t('tab.yes') : ''}}</p>
              <p class="mb-1 p-1" v-if="dataDetail.Oficina_Estudio"><strong>{{ $t('tab.office') }}</strong> {{ dataDetail.Oficina_Estudio == 1 ? $t('tab.yes') : ''}}</p>
              <p class="mb-1 p-1" v-if="dataDetail.Cuarto_Banio_De_Servicio"><strong>{{ $t('tab.serviceRoom') }}</strong> {{ dataDetail.Cuarto_Banio_De_Servicio == 1 ? $t('tab.yes') : ''}}</p>
            </div>
          </div>
          <!-- <div class="attachments mt-4" v-if="attachments.length">
            <h4 class="text-black">Adjuntos</h4>
            <button class="btn btn-pill btn-light-secondary" v-for="attachment in attachments" :key="attachment"><i class="fa-solid fa-file-pdf mr-2"></i>{{ attachment }}</button>
          </div> -->
          <div class="property-brief mt-4" v-if="propertyBrief">
            <h4 class="text-black">{{tab.label}}</h4>
            <!--
              Antes: <p>{{ itemDescLarga }}</p> colapsaba los \n en espacios
              (HTML por defecto ignora whitespace, salvo que se use <pre> o
              CSS). Ahora usamos una <div> con white-space: pre-line para
              preservar los saltos de linea que el admin pone al editar
              la descripcion, sin riesgo de XSS (v-html + replace seria
              menos seguro si el texto viniera sin sanitizar).
            -->
            <div class="property-brief-text">{{ itemDescLarga }}</div>
          </div>
        </template>

        <template v-if="tab.name === 'Caracteristicas'">
        <h3 class="fw-bold mb-4">{{ tab.label }}</h3>

        <!-- Mostrar mensaje si no hay características -->
        <div v-if="!features || features.length === 0">
          <p class="text-secondary">{{ $t('tab.noFeatures') }}</p>
        </div>

        <!-- Mostrar características si hay datos -->
        <div class="row" v-else>
          <div
            class="col-md-4"
            v-if="dataDetail[property.key] > 0"
            v-for="(property, index) in features"
            :key="index"
          >
            <p><i :class="property.icon" class="text-primary me-2"></i> {{ property.label }}</p>
          </div>
        </div>
      </template>

        <template v-if="tab.name === 'Fotos'">
          <div class="d-flex">
            <h3 class="fw-bold mb-4">{{tab.label}}</h3>
            <div class="badge bg-red ml-xl-2 ml-md-2 ml-auto " style="height: 1.8rem; font-size: 1rem;">
              <i class="fas fa-camera"></i> 
              {{ galeryImagen.length }}

            </div>
          
          </div>
          <GalleryProperty :dataGallery="dataDetail.Imagenes" class="mt-3"></GalleryProperty>
        </template>
        <template v-if="tab.name === 'Videos'">
          <div class="d-flex">
            <h3 class="fw-bold mb-4">{{tab.label}}</h3>
            <div class="badge bg-red ml-xl-2 ml-md-2 ml-auto " style="height: 1.8rem; font-size: 1rem;">
              <i class="fas fa-play"></i> 
              {{ galeryVideos.length }}

            </div>
          
          </div>
          <!-- {{ galeryVideos }} -->
          <GalleryProperty :dataGalleryVideo="galeryVideos" class="mt-3"></GalleryProperty>
        </template>

        <template v-if="tab.name === 'Ubicacion'">
          <h3 class="fw-bold mb-4">{{tab.label}}</h3>
          <div class="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18..."
              width="100%"
              height="450"
              style="border:0;"
              allowfullscreen=""
              loading="lazy">
            </iframe>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import GalleryProperty from "../components/GalleryProperty.vue";
import { tField } from "@/i18n";

export default {
  props:["dataDetail", "galeryImagen", "galeryVideos"],

  components: { GalleryProperty },

  data() {
    return {
      currentTab: "",
      attachments: ["Demo Property Document"],
      propertyBrief: "Residences can be classified by and how they are connected to neighbouring residences and land. Different types of housing tenure can be used for the same physical type."
    };
  },
  computed: {
    // Locale reactivo
    currentLocale() {
      return this.$i18n.locale;
    },
    // Tipo de propiedad: viene como objeto anidado (Tipo_de_Propiedad) o plano
    tipoPropiedadNombre() {
      const tipoObj = this.dataDetail?.Tipo_de_Propiedad;
      if (tipoObj && typeof tipoObj === "object") {
        return tField(tipoObj, "Nombre", this.currentLocale);
      }
      return tField(this.dataDetail || {}, "Nombre", this.currentLocale);
    },
    // Descripcion larga bilingue de la propiedad
    itemDescLarga() {
      return tField(this.dataDetail, "Desc_Larga", this.currentLocale);
    },
    tabs() {
      return [
        {
          name: "Detalles",
          label: this.$t("tab.labelDetails"),
        },
        {
          name: "Caracteristicas",
          label: this.$t("tab.labelFeatures"),
        },
        {
          name: "Fotos",
          label: this.$t("tab.labelPhotos"),
        },
        {
          name: "Videos",
          label: this.$t("tab.labelVideos"),
        },
        {
          name: "Ubicacion",
          label: this.$t("tab.labelLocation"),
        }
      ];
    },
    features() {
      return [
        { key: "Piscina", icon: "fa-solid fa-person-swimming", label: this.$t("detail.featurePool") },
        { key: "Parqueos", icon: "fa-solid fa-car", label: this.$t("detail.featureParking") },
        { key: "En_Condominio", icon: "fa-solid fa-building", label: this.$t("detail.featureGated") },
        { key: "Seguridad_247", icon: "fa-solid fa-shield-halved", label: this.$t("detail.featureSecurity24") },
        { key: "Casa_Club", icon: "fa-solid fa-people-roof", label: this.$t("detail.featureClubhouse") },
        { key: "Juegos_Infantiles", icon: "fa-solid fa-children", label: this.$t("detail.featurePlayground") },
        { key: "Gym", icon: "fa-solid fa-dumbbell", label: this.$t("detail.featureGym") },
        { key: "Bodega", icon: "fa-solid fa-shop-lock", label: this.$t("detail.featureStorage") },
        { key: "Cancha_Deportiva", icon: "fa-solid fa-basketball", label: this.$t("detail.featureSportsCourt") },
        { key: "Garaje", icon: "fa-solid fa-warehouse", label: this.$t("detail.featureGarage") },
        { key: "Cuarto_Banio_De_Servicio", icon: "fa-solid fa-house-user", label: this.$t("detail.featureServiceRoom") },
      ];
    },
    visibleTabs() {
      return this.tabs.filter(tab => this.isTabVisible(tab.name));
    },
    hasAboutDetails() {
      return Object.values(this.dataDetail).some(detail => detail);
    }
  },
  methods: {
    isTabVisible(tabName) {
      if (tabName === "Detalles") return this.hasAboutDetails || this.attachments.length || this.propertyBrief;
      if (tabName === "Caracteristicas") return this.features.length;
      if (tabName === "Fotos") return true; // Assume Fotos is always visible for now
      if (tabName === "Videos") return true; // Assume Videos is always visible for now
      if (tabName === "Ubicacion") return true; // Assume Ubicacion is always visible for now
      return false;
    }
  },
  mounted() {
    this.currentTab = this.visibleTabs.length ? this.visibleTabs[0].name : "";
  },

};
</script>
  <style scoped>
  ::-webkit-scrollbar {
  width: 10px !important;
}

/* Track */
::-webkit-scrollbar-track {
  background: #fdfcfc !important; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #e9e9e9 !important; 
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #e9e9e9 !important; 
}
   .tab-menu {
        display: flex;
        padding: 0;
        margin: 0;
        list-style-type: none;
        background-color: var(--bg-card);
        border-bottom: 1px solid #ddd;
    }
    .tab-menu li {
        margin-right: 20px;
        padding: 10px 15px;
        cursor: pointer;
        color: #555;
        font-weight: bold;
    }
    .tab-menu li.active {
        color: var(--primary);
        border-bottom: 2px solid var(--primary);
    }
    
    
    .details {
        display: flex;
        flex-wrap: wrap;
        gap: 15px;
    }
    .details div {
        width: 45%;
        margin-bottom: 10px;
        font-size: 14px;
        color: #555;
    }
    .details div strong {
        color: #333;
    }
    .property-brief {
        margin-top: 20px;
        color: #555;
        font-size: 14px;
        line-height: 1.6;
        max-width: 100%;
        overflow-wrap: anywhere;
        word-break: break-word;
    }

    .property-brief p {
        max-width: 100%;
    }

    /* Preserva los saltos de linea (\n) que el admin pone en la
       descripcion larga al editar la propiedad. Sin esto, HTML los
       colapsa a espacios y todo queda en una sola linea.
       - pre-line: preserva \n como saltos visibles, wrappea texto largo,
         colapsa espacios multiples (a diferencia de pre o pre-wrap).
       Es mas seguro que v-html porque no interpreta markup del texto. */
    .property-brief-text {
        white-space: pre-line;
        max-width: 100%;
        color: #555;
        font-size: 14px;
        line-height: 1.6;
        overflow-wrap: anywhere;
        word-break: break-word;
    }
    .attachments {
        margin-top: 20px;
        font-size: 14px;
    }
    .attachments a {
        text-decoration: none;
        color: var(--primary);
        font-weight: bold;
    }
    .attachments i {
        margin-right: 5px;
    }
    .map-link {
        float: right;
        color: var(--primary);
        font-size: 14px;
        cursor: pointer;
        text-decoration: none;
    }
    @media (max-width: 576px) {
      .tab-menu {
          text-align: center;
          display: block;
          padding: 0;
          margin: 0;
          list-style-type: none;
          background-color: var(--bg-card);
          border-bottom: 1px solid #ddd;
      }
       
    } 
  </style>
